/** The Spanish catalogue for where you were hit — the wording only. Why each entry exists is argued in `en/zone.ts`. */
export default {
  head: 'cabeza',
  chest: 'pecho',
  groin: 'cadera',
  leg_l: 'pierna izquierda',
  leg_r: 'pierna derecha',
  legs: 'piernas',
  arm_l: 'brazo izquierdo',
  arm_r: 'brazo derecho',
};
